import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import FireplaceIcon from '@mui/icons-material/Fireplace';

/**
 * Pictogramme « Article à risque ».
 * - variant="icon" (défaut) : icône flamme seule (lignes, listes, admin).
 * - variant="badge" : chip bordé orange « Article à risque » (en-tête de dossier).
 */
const ArticleARisquePicto = ({ variant = 'icon', fontSize = 'small', color = 'error', ...props }) => {
    if (variant === 'badge') {
        return (
            <Tooltip title="Ce dossier contient des articles à risque">
                <Chip
                    icon={<FireplaceIcon sx={{ color: '#E65100 !important' }} />}
                    label="Article à risque"
                    variant="outlined"
                    size="small"
                    {...props}
                    sx={{
                        backgroundColor: '#FFF3E0',
                        borderColor: '#FFB74D',
                        color: '#E65100',
                        fontWeight: 'bold',
                        px: 0.75,
                        '& .MuiChip-icon': { ml: 0.75, mr: 0.25 },
                        ...props.sx,
                    }}
                />
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Article à risque">
            <FireplaceIcon color={color} fontSize={fontSize} {...props} />
        </Tooltip>
    );
};

export default ArticleARisquePicto;
